import axios from 'axios';

// Use relative URL - nginx proxy will forward to portal-service
const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  subject: string;
  message: string;
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
}

export const contactApi = {
  /**
   * Submit contact form inquiry
   */
  async submitInquiry(data: ContactFormData): Promise<ContactFormResponse> {
    try {
      const response = await axios.post<ContactFormResponse>(
        `${API_BASE_URL}/api/contact/submit`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data;
      }
      throw error;
    }
  },
};

/**
 * Helper function to send contact form
 */
export const sendContactForm = async (
  data: ContactFormData
): Promise<ContactFormResponse> => {
  return contactApi.submitInquiry(data);
};
